/* eslint-disable sort-keys-fix/sort-keys-fix -- order matters for display */
export const PRODUCT_CATEGORY_NAMES: {
  [category: string]: { label: string; path: string; icon: string };
} = {
  Cannabis: { label: "cannabis", path: "/products/cannabis", icon: "flower" },
  Edibles: { label: "edibles", path: "/products/edibles", icon: "edible" },
  Cartridges: {
    label: "cartridges",
    path: "/products/concentrates/cartridges",
    icon: "cartridge",
  },
  Concentrates: {
    label: "concentrates",
    path: "/products/concentrates",
    icon: "concentrate",
  },
  Vaping: { label: "vapes", path: "/products/vaping", icon: "vape" },
  PreRoll: {
    label: "pre-rolls",
    path: "/products/cannabis/prerolls",
    icon: "preroll",
  },
  Smoking: {
    label: "accessories",
    path: "/products/smoking",
    icon: "accessory",
  },
  Growing: { label: "growing", path: "/products/growing", icon: "growing" },
  "Delta-8-THC": {
    label: "delta 8 THC",
    path: "/products/delta-8-thc",
    icon: "delta8",
  },
  Topicals: { label: "topicals", path: "/products/topicals", icon: "topical" },
};
/* eslint-enable sort-keys-fix/sort-keys-fix -- order matters for display  */

export const SUBCATEGORY_LINK_NAMES: { [subcategory: string]: string } = {
  "bath-body": "skin care",
  "batteries-power": "vape batteries",
  "climate-controls": "climate controls",
  "dab-and-oil-rigs": "dab rigs",
  "delta-8-carts": "delta-8 carts",
  "delta-8-concentrates": "delta-8 concentrates",
  "delta-8-edibles": "delta-8 edibles",
  "delta-8-topicals": "delta-8 topicals",
  "desktop-vaporizers": "desktop vaporizers",
  "edible-capsules": "capsules",
  "grow-lights": "grow lights",
  "grow-media": "grow media",
  "grow-tents": "grow tents",
  "hemp-cbd-flower": "hemp-cbd flower",
  "hemp-edibles": "hemp edibles",
  "hemp-oil": "hemp oil",
  "hemp-tinctures": "hemp tinctures",
  "hemp-topicals": "hemp topicals",
  "ingestible-concentrates": "ingestibles",
  "lubricants-oils": "lubricants oils",
  "nails-domes-attatchments": "nails & attatchments",
  "other-apparel": "apparel",
  "other-grow-supplies": "grow supplies",
  "pest-control": "pest control",
  "pet-accessories": "pet accessories",
  "pet-capsules": "pet capsules",
  "pet-sprays": "pet sprays",
  "pet-tinctures": "pet tinctures",
  "pet-treats": "pet treats",
  "portable-vaporizers": "portable vapes",
  "posters-art": "posters",
  "rick-simpson-oil": "rick simpson oil",
  "snack-foods": "snacks",
  "testers-meters": "testers & meters",
  "tinctures-sublingual": "tinctures",
  "tools-accessories": "dab tools",
  "transdermal-patches": "transdermal patches",
  "vape-pens": "vape pens",
  "vaporizer-accessories": "vaporizer accessories",
};
